import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const ZapierShape = {};

export interface ZapierInput {}

yupResolver<ZapierInput>(Yup.object().shape(ZapierShape));
